"use strict";

exports.__esModule = true;
var _PluginContext = require("./PluginContext");
Object.keys(_PluginContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PluginContext[key]) return;
  exports[key] = _PluginContext[key];
});